import { Component, Suspense } from 'react'

class DeferredChunkErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    }
  }

  componentDidCatch(error) {
    console.error('Deferred chunk failed to load.', error)
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorFallback ?? null
    }

    return this.props.children
  }
}

function DeferredBoundary({
  children,
  fallback = null,
  errorFallback = null,
}) {
  return (
    <DeferredChunkErrorBoundary errorFallback={errorFallback}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </DeferredChunkErrorBoundary>
  )
}

export default DeferredBoundary
